import styled from 'styled-components';
import { Tooltip } from 'ui/tooltip';

export const StyledTopTooltip = styled(Tooltip)`
  width: 100%;
  [data-test='tooltip-trigger'] {
    width: 100%;
    padding: 0;
    border: none;
  }
`;
